import { create } from 'zustand';
import { ApiUtils, CardApi, CardEntity, RequestStrategyEnum } from '@shared/api';

interface IReplaceCardStore {
  loading: boolean;
  error: string | null;
  card: CardEntity[];
  replaceCard: (accountId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useReplaceCardStore = create<IReplaceCardStore>((set) => ({
  loading: false,
  error: null,
  card: [],

  replaceCard: ApiUtils.wrapperApi(async (accountId: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await CardApi.replaceCard(accountId, signal);
      set({ card: result ?? [], loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ card: [], loading: false, error: null }),
}));
